

/* ===========================
   MODULE DATA
=========================== */
export const MODULES = {
    'bagis-finans': {
        title: 'Finans',
        subtitle: 'Bağıştan raporlamaya kadar tüm mali süreçleri tek merkezden yönetin.',
        image: '/assets/icon/heart2.webp',
        color: '#f97316',
        features: [
            {
                image: '/assets/icon/donation.webp',
                title: 'Bağış & Gelir Yönetimi',
                desc: 'Tüm bağış ve gelirleri tek ekrandan yönetin, kategorilere ayırın ve raporlayın.',
                microFeatures: ['Bağışçıları takip edin', 'Bağışları kategorize edin', 'Anlık raporları görüntüleyin'],
            },
            {
                image: '/assets/icon/toys.webp',
                title: 'Kampanya & Fon Yönetimi',
                desc: 'Hedefli, izlenebilir ve güven veren bağış kampanyaları oluşturun.',
                microFeatures: [
                    'Hedef belirleyin',
                    'İlerlemeyi anlık izleyin',
                    'Şeffaf kampanya raporları'
                ]
            },
            // {
            //     image: '/assets/icon/box.webp',
            //     title: 'Kumbara & Saha Bağışları',
            //     desc: 'Fiziksel bağışları dijital sisteme entegre edin, sahadan anında takip edin.',
            //     microFeatures: [
            //         'QR kodlu bağış sistemi',
            //         'Sahadan anlık veri girişi',
            //         'Merkezi bağış takibi'
            //     ]
            // },
            {
                image: '/assets/icon/card-machine.webp',
                title: 'POS & Banka Entegrasyonu',
                desc: 'Banka hesapları ve sanal POS’lar ile otomatik tahsilat ve anlık raporlama sağlayın.',
                microFeatures: [
                    'Sanal POS entegrasyonu',
                    'Banka hesap senkronizasyonu',
                    'Otomatik mutabakat'
                ]
            },
            {
                image: '/assets/icon/accounting.webp',
                title: 'Muhasebe & Kasa Yönetimi',
                desc: 'Gelir–gider, kasa ve banka hareketlerini düzenli ve denetlenebilir şekilde yönetin.',
                microFeatures: [
                    'Otomatik kayıt oluşturma',
                    'Kategori bazlı takip',
                    'Detaylı finansal tablolar'
                ]
            },
            {
                image: '/assets/icon/loan.webp',
                title: 'Üye Aidat Yönetimi',
                desc: 'Aidatları dönemsel olarak tanımlayın, tahsilatları otomatik takip edin.',
                microFeatures: [
                    'Dönem bazlı aidat',
                    'Otomatik borçlandırma',
                    'Tahsilat durumu'
                ],
            },
            {
                image: '/assets/icon/accounting.webp',
                title: 'Muhasebe & Kasa Takibi',
                desc: 'Günlük gelir–gider hareketlerini ve kasa durumunu anlık izleyin.',
                microFeatures: [
                    'Kasa & banka bakiyesi',
                    'Fiş / kayıt mantığı',
                    'Detaylı muhasebe dökümü'
                ],
            },
        ],
    },
    'uye-crm': {
        title: 'Üyeler',
        subtitle: 'Üyelerinizi sadece kayıt altında değil, sistemin merkezinde yönetin.',
        color: '#0891b2',
        features: [
            {
                image: '/assets/icon/team.webp',
                title: 'Üye Yönetimi',
                desc: 'Üye kayıtlarını, bilgilerini ve durumlarını tek panelden yönetin.',
                microFeatures: ['Hızlı kayıt', 'Toplu işlemler', 'İleri arama'],
            },
            {
                image: '/assets/icon/people.webp',
                title: 'Üye Profilleri',
                desc: 'Her üye için detaylı profil, geçmiş işlemler ve etkileşim kayıtlarını tek yerde görün.',
                microFeatures: [
                    '360° üye görünümü',
                    'İşlem geçmişi',
                    'Etkileşim takibi'
                ],
            },
            {
                image: '/assets/icon/user-management.webp',
                title: 'Rol & Yetkilendirme',
                desc: 'Yönetici, editör ve üye rolleriyle güvenli ve kontrollü erişim yapısı oluşturun.',
                microFeatures: [
                    'Rol bazlı erişim',
                    'Özel yetkilendirme',
                    'Güvenli işlem kontrolü'
                ],
            },
            {
                image: '/assets/icon/internet.webp',
                title: 'Üye Portalı',
                desc: 'Üyeler kendi bilgilerini, aidatlarını ve etkinliklerini takip edebilsin.',
                microFeatures: [
                    'Kişisel üye paneli',
                    'Aidat ve ödeme takibi',
                    'Etkinliklere kayıt'
                ],
            },
            {
                image: '/assets/icon/analysis.webp',
                title: 'Üye İstatistikleri',
                desc: 'Aktif–pasif üye durumu ve katılım analizlerini anlık görüntüleyin.',
                microFeatures: ['Aktiflik analizi', 'Katılım oranları', 'Trend grafikleri'],
            },
        ],
    },
    'web-icerik': {
        title: 'Web & İçerik',
        subtitle: 'Derneğinizin dijital yüzünü profesyonel ve güçlü bir şekilde yönetin.',
        color: '#10b981',
        features: [
            {
                image: '/assets/icon/window.webp',
                title: 'Widget Tabanlı Web Sitesi',
                desc: 'Sürükle–bırak widget’lar ile web sitenizi tamamen özgürce tasarlayın.',
                microFeatures: ['Drag & Drop', 'Anında önizleme', 'Responsive tasarım'],
            },
            {
                image: '/assets/icon/advertisement.webp',
                title: 'Haber & Duyuru Sayfaları',
                desc: 'Haber, duyuru ve bilgilendirme içeriklerini kolayca yönetin.',
                microFeatures: ['Zengin editör', 'Programlı yayın', 'Kategorizasyon'],
            },
            {
                image: '/assets/icon/project.webp',
                title: 'Proje & Kampanya Sayfaları',
                desc: 'Faaliyet ve projelerinize özel sayfalar oluşturun.',
                microFeatures: [
                    'Hazır şablonlar',
                    'İlerleme göstergeleri',
                    'Bağış entegrasyonu'
                ],
            },
            {
                image: '/assets/icon/gallery.webp',
                title: 'Görsel Galeri & Medya',
                desc: 'Fotoğraf, video ve dokümanlarınızı düzenli şekilde yönetin.',
                microFeatures: ['Albüm sistemi', 'Video entegrasyonu', 'Hızlı yükleme'],
            },
            {
                image: '/assets/icon/seo.webp',
                title: 'SEO Yönetimi',
                desc: 'Sayfa bazlı SEO ayarları ile arama motorlarında görünür olun.',
                microFeatures: ['Meta etiketleri', 'URL optimizasyonu', 'Sitemap'],
            },
        ],
    },
    'proje-faaliyet': {
        title: 'Projeler',
        subtitle: 'Derneğinizin sahadaki tüm çalışmalarını sistematik hale getirin.',
        color: '#6366f1',
        features: [
            {
                image: '/assets/icon/society.webp',
                title: 'Faaliyet Yönetimi',
                desc: 'Tüm faaliyetleri planlayın, takip edin ve raporlayın.',
                microFeatures: ['Takvim görünümü', 'Görev atama', 'İlerleme takibi'],
            },
            {
                image: '/assets/icon/task-management.webp',
                title: 'Proje Bazlı Takip',
                desc: 'Her proje için bütçe, ilerleme ve sonuçları ayrı ayrı yönetin.',
                microFeatures: ['İlerleme aşamaları', 'Bütçe kontrolü', 'Ekip takibi'],
            },
            {
                image: '/assets/icon/project-fon.webp',
                title: 'Proje Fonlama',
                desc: 'Her proje için ayrı fonlama ve bağış akışları oluşturun.',
                microFeatures: ['Özel kampanyalar', 'Hedef takibi', 'Sponsor yönetimi'],
            },
            {
                image: '/assets/icon/food-donation.webp',
                title: 'Ayni Yardımlar',
                desc: 'Malzeme, depo ve dağıtım süreçlerini dijital olarak takip edin.',
                microFeatures: ['Stok yönetimi', 'Dağıtım takibi', 'Belgelendirme'],
            },
            {
                image: '/assets/icon/time-management.webp',
                title: 'Faaliyet Raporları',
                desc: 'Faaliyet sonuçlarını görsel ve raporlarla belgeleyin.',
                microFeatures: ['Otomatik raporlar', 'Görsel analizler', 'PDF dışa aktarma'],
            },
        ],
    },
    'iletisim-etkinlik': {
        title: 'İletişim',
        subtitle: 'Üyelerinizle düzenli, hedefli ve etkili iletişim kurun.',
        color: '#ec4899',
        features: [
            {
                image: '/assets/icon/bulk-email.webp',
                title: 'Toplu E-posta & SMS',
                desc: 'Üyelere hedefli ve toplu e-posta ve SMS gönderimleri yapın.',
                microFeatures: ['Şablon sistemi', 'Segmentasyon', 'Teslimat takibi'],
            },
            {
                image: '/assets/icon/event.webp',
                title: 'Etkinlik Yönetimi',
                desc: 'Etkinlik planlama, katılımcı takibi ve duyuru süreçlerini yönetin.',
                microFeatures: ['Kolay oluşturma', 'Online kayıt', 'QR check-in'],
            },
            {
                image: '/assets/icon/attendance.webp',
                title: 'Katılım Takibi',
                desc: 'Etkinliklere katılım durumunu detaylı şekilde takip edin.',
                microFeatures: ['Anlık takip', 'Katılım raporu', 'Geçmiş analizi'],
            },
            {
                image: '/assets/icon/notifications.webp',
                title: 'Bildirimler',
                desc: 'Anlık gelişmeler için sistem içi ve mobil bildirimler gönderin.',
                microFeatures: ['Push bildirimler', 'Sistem içi uyarılar', 'Anlık bilgilendirme'],
            },
            {
                image: '/assets/icon/bell.webp',
                title: 'Hatırlatma Sistemleri',
                desc: 'Aidat, etkinlik ve duyurular için otomatik hatırlatmalar.',
                microFeatures: ['Programlı hatırlatma', 'Özelleştirilebilir', 'Çoklu kanal'],
            },
        ],
    },
    'raporlama-kontrol': {
        title: 'Raporlama',
        subtitle: 'Yönetimi sezgiyle değil, verilerle yapın.',
        color: '#8b5cf6',
        features: [
            {
                image: '/assets/icon/chart.webp',
                title: 'Gelişmiş Raporlama',
                desc: 'Tüm modüllerden gelen verileri detaylı raporlar halinde görüntüleyin.',
                microFeatures: [
                    'Aidat tahsilat raporları',
                    'Bağış & gelir analizleri',
                    'Dönemsel finans tabloları'
                ],
            },
            {
                image: '/assets/icon/dashboard.webp',
                title: 'KPI Dashboardları',
                desc: 'Derneğinizin performansını tek bakışta analiz edin.',
                microFeatures: ['Özel metrikler', 'Grafik gösterimi', 'Anlık veri'],
            },
            {
                image: '/assets/icon/research.webp',
                title: 'Şeffaf Yönetim Takibi',
                desc: 'Tüm kullanıcı işlemlerini zaman bazlı ve şeffaf şekilde takip edin.',
                microFeatures: ['İşlem kayıtları', 'Kullanıcı bazlı takip', 'Zaman damgalı kayıtlar'],
            },
            {
                image: '/assets/icon/folder.webp',
                title: 'Doküman & Belge Arşivi',
                desc: 'Resmi evrakları güvenli ve yetkilendirmeli şekilde saklayın.',
                microFeatures: ['Kategorize depolama', 'Versiyon kontrolü', 'Yetki bazlı erişim'],
            },
            {
                image: '/assets/icon/clean-computer-virus.webp',
                title: 'Güvenlik & Kayıtlar',
                desc: 'Sistem güvenliği, denetim ve yasal uyum süreçlerini kontrol altında tutun.',
                microFeatures: ['Denetim kayıtları', 'Güvenlik raporları', 'KVKK uyumluluğu'],
            },
        ],
    },
};
